// import { useDisclosure } from "@chakra-ui/hooks";
// import DarkButton from "components/actions/DarkButton";
// import GrayButton from "components/actions/GrayButton";
// import Dialog from "components/dialog";
// import InputField from "components/fields/InputField";
// import DeleteIcon from "components/icons/DeleteIcon";
// import EyeIcon from "components/icons/EyeIcon";
// import EyeOffIcon from "components/icons/EyeOffIcon";
// import PenEditIcon from "components/icons/PenEditIcon";
// import PlusIcon from "components/icons/PlusIcon";
// import TrashIcon from "components/icons/TrashIcon";
import AtriumApi from "api";
import Loader from "components/loader/Loader";
import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import DeleteStaff from "./delete";

// const DeviceForm = ({ device, isOpen, onClose }) => {
//   const saveDevice = () => {};

//   return (
//     <Dialog isOpen={isOpen} onClose={onClose} placement="top">
//       <div className="text-lg font-bold dark:text-white mt-4">
//         {device?.id ? "Edit credentials" : "Create device"}
//       </div>

//       <InputField
//         variant="device_form"
//         label="Login"
//         placeholder=""
//         type="text"
//         id="login"
//         extra="flex-1 flex flex-col mt-6"
//       />
//       <InputField
//         variant="device_form"
//         label="Password"
//         placeholder=""
//         type="password"
//         id="password"
//         extra="flex-1 flex flex-col mt-6"
//       />

//       <div className="flex flex-row gap-4 mt-6">
//         <DarkButton onClick={saveDevice}>
//           {device?.id ? "Save credentials" : "Create device"}
//         </DarkButton>
//         <GrayButton onClick={onClose}>Cancel</GrayButton>
//       </div>
//     </Dialog>
//   );
// };

// const DeleteAlert = ({ device, isOpen, onClose }) => {
//   const deleteDevice = () => {};

//   return (
//     <Dialog isOpen={isOpen} onClose={onClose} placement="top">
//       <h2 className="text-lg font-bold dark:text-white my-4">
//         Delete check-in device
//       </h2>

//       <div className="text-gray-700 text-sm">
//         Are you sure you want to delete{" "}
//         <span className="font-bold text-navy-800 dark:text-white">
//           {device.name}
//         </span>{" "}
//         check-in device?
//       </div>

//       <div className="flex flex-row gap-4 mt-6">
//         <DarkButton onClick={deleteDevice}>Delete</DarkButton>
//         <GrayButton onClick={onClose}>Cancel</GrayButton>
//       </div>
//     </Dialog>
//   );
// };

const DevicesManagement = () => {
  // const formDlgDisclosure = useDisclosure();
  // const alertDlgDisclosure = useDisclosure();
  const [device, setDevice] = useState([]);
  const [loading, setLoading] = useState(false);

  // const addDevice = (dev) => {
  //   setDevice({});
  //   formDlgDisclosure.onOpen();
  // };

  // const editDevice = (dev) => {
  //   setDevice({ id: 100 });
  //   formDlgDisclosure.onOpen();
  // };

  // const deleteDevice = (dev) => {
  //   setDevice({ name: "ryanpad1" });
  //   alertDlgDisclosure.onOpen();
  // };

  // const users = [
  //   { id: 1, login: "Abdul", password: "password" },
  //   { id: 2, login: "CodeXperts", password: "secret123" },
  //   { id: 3, login: "DevOps", password: "secret123" },
  //   { id: 4, login: "Aoun", password: "secret123" },
  // ];

  // const [visiblePasswords, setVisiblePasswords] = useState({});

  // const togglePasswordVisibility = (id) => {
  //   setVisiblePasswords((prev) => ({
  //     ...prev,
  //     [id]: !prev[id],
  //   }));
  // };

  // const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  // const openDeleteModal = () => setIsDeleteOpen(true);
  // const closeDeleteModal = () => setIsDeleteOpen(false);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        setLoading(true);
        const response = await AtriumApi.get(`/v2/devices/all-devices`);
        if (response) {
          setLoading(false);
          setDevice(response?.data?.data?.data);
        }
      } catch (error) {
        setLoading(true);
        console.error(error);
      }
    };

    fetchDevices();
  }, []);

  return (
    <>
      <div className="w-full block md:flex flex-row relative items-start rounded-[15px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none mb-5">
        {loading ? (
          <div className="w-full h-full flex justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className="flex-1 mb-6">
              <h2 className="font-bold text-lg mb-2">People Counter Devices</h2>
              <p className="text-gray-700 text-sm">
                People counter devices IMEIs
              </p>
            </div>

            <div className="flex-2 overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-700">
                <thead className="uppercase text-gray-700 font-medium border-b border-gray-300">
                  <tr>
                    <th className="py-4 pr-4 whitespace-nowrap w-60">
                      Device Name
                    </th>
                    <th className="py-4 whitespace-nowrap w-60">IMEI</th>
                    <th className="py-4 whitespace-nowrap w-60">SSID</th>
                    <th className="py-4 whitespace-nowrap w-60">Location</th>
                  </tr>
                </thead>
                <tbody>
                  {device?.length > 0 ? (
                    device?.map((device, index) => (
                      <tr key={index} className="border-b border-gray-300">
                        <td className="py-4 font-bold whitespace-nowrap">
                          {device?.deviceName}
                        </td>
                        <td className="py-4 whitespace-nowrap">
                          {device?.deviceId}
                        </td>
                        <td className="py-4 whitespace-nowrap">
                          {device?.ssid}
                        </td>
                        <td className="py-4 whitespace-nowrap">
                          {device?.deviceLocation}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="border-b border-gray-300">
                      <td className="py-4 font-bold whitespace-nowrap">
                        No devices found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* <div className="mt-6">
            <p>
              To add more devices, please{" "}
              <Link className="text-brand-600 font-medium" to=" ">
                Contact Support
              </Link>
            </p>
          </div> */}
            </div>
          </>
        )}
      </div>

      {/* <DeviceForm
        isOpen={formDlgDisclosure.isOpen}
        onClose={formDlgDisclosure.onClose}
        device={device}
      /> */}
      {/* <DeleteAlert
        isOpen={alertDlgDisclosure.isOpen}
        onClose={alertDlgDisclosure.onClose}
        device={device}
      /> */}
      {/* <DeleteStaff isOpen={isDeleteOpen} onClose={closeDeleteModal} /> */}
    </>
  );
};

export default DevicesManagement;
